import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function GoalDeflection({ deflected }) {
  const classes = useStyles();

  if(!deflected){
    return null;
  }

  return (
    <>
      {' '}on a deflection from a shot by{' '}
      <span className={classes.bold}>{deflected.name}</span>
    </>
  )
}

export default GoalDeflection;
